import { myAccountViewStyles } from "@insite/content-library/Widgets/MyAccount/MyAccountView";
import { css } from "styled-components";

myAccountViewStyles.accountMessagesGridItem = { 
    width: 12,
    css:css`
        display:none;
    `, 
}